import { Navigate } from 'react-router-dom'
import auth from './auth-helper'

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <>
      {auth.isAuthenticated() ?
        <Component child={rest.child} /> : <Navigate to={{
          pathname: '/',
          state: { from: '' }
        }} />}
      {/* <Route {...rest} render={props => (
        auth.isAuthenticated() ? (
          <Component {...props} child={rest.child} />
        ) : (
          <Navigate to={{
            pathname: '/',
            state: { from: props.location }
          }} />
        )
      )} /> */}
    </>

  );

}

export default PrivateRoute;
